import './App.css';
import Navigation from './Comp/Navigation'
import Home from './Comp/Home'
import Footer from './Comp/Footer'
import MobileNavigation from './Comp/MobileNavigation'
import MerchList from './Comp/MerchList'
import About from './Comp/About'
import Find from './Comp/Find'
import Revue from './Comp/Revue'
import Memegor from './Comp/Memegor'
import Nichijou from './Comp/Nichijou'
import Miku from './Comp/Miku'
import Shimeji from './Comp/Shimeji'

//page list here
import MemegorA3 from './Merch/Memegor/memegor-a3'
import MemegorA5 from './Merch/Memegor/memegor-a5'
import MemegorDawkinsA3 from './Merch/Memegor/memegor-dawkins-a3'
import MemegorDawkinsA5 from './Merch/Memegor/memegor-dawkins-a5'
import MemegorGanci from './Merch/Memegor/memegor-ganci'
import MemegorPin from './Merch/Memegor/memegor-pin'
import MemegorZine from './Merch/Memegor/memegor-zine'

import MikuPosterA3 from './Merch/Miku/miku-poster-a3'
import MikuPosterA5 from './Merch/Miku/miku-poster-a5'
import MikuStickerBundling from './Merch/Miku/miku-sticker-budling'
import MikuSticker from './Merch/Miku/miku-sticker'

import NichijouGanci from './Merch/Nichijou/nichijou-ganci'
import NichijouPin from './Merch/Nichijou/nichijou-pin'
import NichijouSticker from './Merch/Nichijou/nichijou-sticker'

import ShimejiGanciBundle from './Merch/Shimeji/shimeji-ganchi-bundle'
import ShimejiGanciMajime from './Merch/Shimeji/shimeji-ganci-majime'
import ShimejiGanciShimeji from './Merch/Shimeji/shimeji-ganci-shimeji'
import ShimejiPosterA3 from './Merch/Shimeji/shimeji-poster-a3'
import ShimejiPosterA5 from './Merch/Shimeji/shimeji-poster-a5'

import RevueSuzudalGanci from './Merch/Revue/revue-suzudal-ganci'
import RevueSuzudalPin from './Merch/Revue/revue-suzudal-pin'
import RevueSuzudalSet from './Merch/Revue/revue-suzudal-set'
import RevueSuzudalSticker from './Merch/Revue/revue-suzudal-sticker'
import RevueWhiteGanci from './Merch/Revue/revue-white-ganci'
import RevueWhitePin from './Merch/Revue/revue-white-pin'
import RevueWhiteSet from './Merch/Revue/revue-white-set'
import RevueWhiteSticker from './Merch/Revue/revue-white-sticker'

import "animate.css/animate.min.css";
import 'animate.css';

import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';


function App() {
  return (
    <>
    <Router>
    <React.Fragment>
      <div>
        <div className=" w-full min-h-screen">
          {/* Navigation */}
          <div className="lg:flex hidden w-80 h-screen fixed ">
            <Navigation />
          </div>
          <div className="flex lg:hidden w-full h-32 fixed">
            <MobileNavigation />
          </div>

          {/* Content */}
          <div className="w-full min-h-screen  lg:pl-80 lg:px-10 px-5 pt-10">
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/merch" element={<MerchList />} />
              <Route exact path="/merch-memegoreng" element={<Memegor />} />
              <Route exact path="/merch-revue" element={<Revue />} />
              <Route exact path="/merch-nichijou" element={<Nichijou />} />
              <Route exact path="/merch-miku" element={<Miku />} />
              <Route exact path="/merch-shimeji" element={<Shimeji />} />
              <Route exact path="/find" element={<Find />} />
              <Route exact path="/about" element={<About />} />
              {/* Memegor */}
              <Route exact path="/memegor-dawkins-a5" element={<MemegorDawkinsA5 />} />
              <Route exact path="/memegor-dawkins-a3" element={<MemegorDawkinsA3 />} />
              <Route exact path="/memegor-a3" element={<MemegorA3 />} />
              <Route exact path="/memegor-a5" element={<MemegorA5 />} />
              <Route exact path="/memegor-ganci" element={<MemegorGanci />} />
              <Route exact path="/memegor-pin" element={<MemegorPin />} />
              <Route exact path="/memegor-zine" element={<MemegorZine />} />
              {/* Miku */}
              <Route exact path="/miku-poster-a3" element={<MikuPosterA3 />} />
              <Route exact path="/miku-poster-a5" element={<MikuPosterA5 />} />
              <Route exact path="/miku-sticker-bundling" element={<MikuStickerBundling />} />
              <Route exact path="/miku-sticker" element={<MikuSticker />} />
              {/* Revue */}
              <Route exact path="/revue-suzudal-set" element={<RevueSuzudalSet />} />
              <Route exact path="/revue-white-set" element={<RevueWhiteSet />} />
              <Route exact path="/revue-suzudal-sticker" element={<RevueSuzudalSticker />} />
              <Route exact path="/revue-white-sticker" element={<RevueWhiteSticker />} />
              <Route exact path="/revue-suzudal-ganci" element={<RevueSuzudalGanci />} />
              <Route exact path="/revue-white-ganci" element={<RevueWhiteGanci />} />
              <Route exact path="/revue-white-pin" element={<RevueWhitePin />} />
              <Route exact path="/revue-suzudal-pin" element={<RevueSuzudalPin />} />
              {/* Shimeji */}
              <Route exact path="/shimeji-poster-a3" element={<ShimejiPosterA3 />} />
              <Route exact path="/shimeji-poster-a5" element={<ShimejiPosterA5 />} />
              <Route exact path="/shimeji-ganci-shimeji" element={<ShimejiGanciShimeji />} />
              <Route exact path="/shimeji-ganci-majime" element={<ShimejiGanciMajime />} />
              <Route exact path="/shimeji-ganchi-bundle" element={<ShimejiGanciBundle />} />
              {/* Nichijou */}
              <Route exact path="/nichijou-pin" element={<NichijouPin />} />
              <Route exact path="/nichijou-sticker" element={<NichijouSticker />} />
              <Route exact path="/nichijou-ganci" element={<NichijouGanci />} />

            </Routes>
            <Footer />
          </div>
        </div>
      </div>
    </React.Fragment>
    </Router>
    </>
  );
}

export default App;
